module.exports = __webpack_public_path__ + "static/media/percent-chart.d01b5626.svg";